<template>
  <EButton
    class="notification-pill"
    icon="bell"
    icon-size="s"
    :class="{ highlight }"
    :active="highlight"
    v-on="$listeners"
    @click="onClick"
  >
    <span v-if="highlight" class="notification-pill__alert" />
    {{ $t('common.header.notifications.unread') }}
  </EButton>
</template>

<script>
import { mapState } from 'vuex';

import { LAST_READ_NOTIFICATION as LAST_READ_NOTIFICATION_COOKIE } from '~~/common/js/constants/cookies';
import { getCookieOptions, isDateInLastDays } from '~~/common/js/universal/utils';
import { sendEvent, sendCoreAnalyticsEvent } from '~~/common/js/client/analytics';
import EButton from '~~/common/vue/components/button';

import {
  MIN_TREE_COUNT_PILL,
  NOTIFICATION_DAYS_PILL,
  NOTIFICATION_LEVEL_PILL,
} from './constants';

export default {
  name: 'ENotificationPill',
  components: {
    EButton,
  },
  data() {
    return {
      dismissed: false,
      impressionEventSent: false,
    };
  },
  computed: {
    ...mapState('user', [
      'lastReadNotificationTimestamp',
      'notificationEnabled',
      'treeCount',
    ]),
    notification() {
      return this.$store.getters['notifications/getForLevel'](NOTIFICATION_LEVEL_PILL);
    },
    highlight() {
      if (this.dismissed || !this.notification) {
        return false;
      }
      const minTreeCount = this.treeCount >= MIN_TREE_COUNT_PILL;
      const publishDate = new Date(this.notification.publish_date).getTime();
      const publishedRecently = isDateInLastDays(publishDate, NOTIFICATION_DAYS_PILL);
      const neverSeen = (
        !this.lastReadNotificationTimestamp ||
        (
          this.lastReadNotificationTimestamp &&
          new Date(this.lastReadNotificationTimestamp) < publishDate
        )
      );

      return (
        this.notificationEnabled &&
        minTreeCount &&
        publishedRecently &&
        neverSeen
      );
    },
  },
  mounted() {
    this.unwatch = this.$watch('highlight', this.sendImpressionEvent.bind(this), { immediate: true });
  },
  beforeDestroy() {
    if (this.unwatch) {
      this.unwatch();
    }
  },
  methods: {
    sendEvent(name) {
      sendEvent(name, { origin: 'center' });
      sendCoreAnalyticsEvent(name, { origin: 'center' });
    },
    sendImpressionEvent(highlight) {
      if (highlight && !this.impressionEventSent) {
        this.sendEvent('all_notification_impression');
        this.impressionEventSent = true;
      }
    },
    storeLastRead() {
      const key = LAST_READ_NOTIFICATION_COOKIE;
      const value = Date.now();
      const options = getCookieOptions();
      this.$cookieManager.set(key, value, options);
    },
    onClick() {
      this.dismissed = true;
      this.storeLastRead();
    },
  },
};
</script>

<style lang="scss">
.notification-pill.highlight .notification-pill__alert {
  height: $space-s;
  width: $space-s;
  background-color: $c-red-30;
  border-radius: $border-radius-full;
  position: absolute;
  top: 0;
  right: 0;
}
</style>
